import {SWALLOW_ADULT01_BINDINGS} from './swallow-adult01-bindings.js';
import {WREN_CORE04_BINDINGS} from './wren-core04-bindings.js';
import {BUTTERFLY_FOUR_WING_BINDINGS} from './butterfly-four-wing-bindings.js';
import {ROBIN_CORE10_BINDINGS} from './robin-core10-bindings.js';
// Renderer-specific compatibility bindings for exact reviewed exports.
// The generic registry owns asset selection, identity, provenance and evidence.
export const THREE_ANIMAL_BINDINGS = {
  "001c74bda3317d7a2b83ad56ec21277064df7e8c017da1ca432b5dbbdc192df3": {family:"frog",sha256:"001c74bda3317d7a2b83ad56ec21277064df7e8c017da1ca432b5dbbdc192df3",assetProfile:"frog-v21-bank-study-v2",authoritativeProfile:true},
  "eaaa929aa67c36e01d6848633fa33e39741d9961459666a621a7c61d6054ba04": {family:"frog",sha256:"eaaa929aa67c36e01d6848633fa33e39741d9961459666a621a7c61d6054ba04",assetProfile:"frog-v21-bank-study-v2",authoritativeProfile:true},

  "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4": {
    "family": "deer",
    "assetProfile": "doe-original-rig-study",
    "originalRigMode": "procedural",
    "clip": "Stand",
    "clipTime": 0,
    "authoritativeProfile": true,
    "coatVariation": true
  },
  "5dc17284df270558928b161b459f8183611eee7701e1aaf3476e35400971899d": {
    "family": "deer",
    "assetProfile": "doe-original-rig-study",
    "originalRigMode": "procedural",
    "clip": "Stand",
    "clipTime": 0,
    "authoritativeProfile": true,
    "coatVariation": true
  },
  "948d6db8d67f6bc3040313d8a6334d4eab1c410d352fb03c2696594514da066d": {
    "family": "frog",
    "roles": {
      "frog_body": {
        "canonical_role": "frog_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "frog_thigh_L": {
        "canonical_role": "frog_thigh_L",
        "pivot_three": [
          -0.047,
          0.024,
          0.025
        ]
      },
      "frog_shin_L": {
        "canonical_role": "frog_shin_L",
        "pivot_three": [
          -0.079,
          0.01,
          0.06
        ]
      },
      "frog_foreleg_L": {
        "canonical_role": "frog_foreleg_L",
        "pivot_three": [
          -0.044,
          0.027,
          -0.033
        ]
      },
      "frog_thigh_R": {
        "canonical_role": "frog_thigh_R",
        "pivot_three": [
          0.047,
          0.024,
          0.025
        ]
      },
      "frog_shin_R": {
        "canonical_role": "frog_shin_R",
        "pivot_three": [
          0.079,
          0.01,
          0.06
        ]
      },
      "frog_foreleg_R": {
        "canonical_role": "frog_foreleg_R",
        "pivot_three": [
          0.044,
          0.027,
          -0.033
        ]
      }
    }
  },
  "1229f5330f8aa9e805e4b9dbf009193c05bcf358b1e288ae43232f896a700df4": {
    "family": "frog",
    "roles": {
      "frog_body_proxy": {
        "canonical_role": "frog_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "frog_thigh_L_proxy": {
        "canonical_role": "frog_thigh_L",
        "pivot_three": [
          -0.047,
          0.024,
          0.025
        ]
      },
      "frog_shin_L_proxy": {
        "canonical_role": "frog_shin_L",
        "pivot_three": [
          -0.079,
          0.01,
          0.06
        ]
      },
      "frog_foreleg_L_proxy": {
        "canonical_role": "frog_foreleg_L",
        "pivot_three": [
          -0.044,
          0.027,
          -0.033
        ]
      },
      "frog_thigh_R_proxy": {
        "canonical_role": "frog_thigh_R",
        "pivot_three": [
          0.047,
          0.024,
          0.025
        ]
      },
      "frog_shin_R_proxy": {
        "canonical_role": "frog_shin_R",
        "pivot_three": [
          0.079,
          0.01,
          0.06
        ]
      },
      "frog_foreleg_R_proxy": {
        "canonical_role": "frog_foreleg_R",
        "pivot_three": [
          0.044,
          0.027,
          -0.033
        ]
      }
    }
  },
  "89edfe272582616ada80c2438299844f4337fd143914f234e0ca5d9f74be0fb4": {
    "family": "butterfly",
    "roles": {
      "butterfly_monarch_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "butterfly_monarch_wing_L": {
        "canonical_role": "butterfly_wing_L",
        "pivot_three": [
          -0.005,
          0,
          -0.013
        ]
      },
      "butterfly_monarch_wing_R": {
        "canonical_role": "butterfly_wing_R",
        "pivot_three": [
          0.005,
          0,
          -0.013
        ]
      }
    },
    "variant": 0
  },
  "35ddaa541fe59ed56a7f2d4f539712c0a017239343cfd1884a1e828cae11657d": {
    "family": "butterfly",
    "roles": {
      "butterfly_monarch_body_proxy": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "butterfly_monarch_wing_L_proxy": {
        "canonical_role": "butterfly_wing_L",
        "pivot_three": [
          -0.005,
          0,
          -0.013
        ]
      },
      "butterfly_monarch_wing_R_proxy": {
        "canonical_role": "butterfly_wing_R",
        "pivot_three": [
          0.005,
          0,
          -0.013
        ]
      }
    },
    "variant": 0
  },
  "444568e22dd87ca97af0c31b438d6af2cef2ed496e1388e9400850746ebc4be4": {
    "family": "butterfly",
    "roles": {
      "butterfly_common_blue_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "butterfly_common_blue_wing_L": {
        "canonical_role": "butterfly_wing_L",
        "pivot_three": [
          -0.005,
          0,
          -0.013
        ]
      },
      "butterfly_common_blue_wing_R": {
        "canonical_role": "butterfly_wing_R",
        "pivot_three": [
          0.005,
          0,
          -0.013
        ]
      }
    },
    "variant": 1
  },
  "6bfec9cd38de6456b8087f6eb3a0c2e51bdbfdd5face30d545e51e8edaa337d8": {
    "family": "butterfly",
    "roles": {
      "butterfly_common_blue_body_proxy": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "butterfly_common_blue_wing_L_proxy": {
        "canonical_role": "butterfly_wing_L",
        "pivot_three": [
          -0.005,
          0,
          -0.013
        ]
      },
      "butterfly_common_blue_wing_R_proxy": {
        "canonical_role": "butterfly_wing_R",
        "pivot_three": [
          0.005,
          0,
          -0.013
        ]
      }
    },
    "variant": 1
  },
  "60fdc8d723c4325a09226660eccd4a11b41f57f0021a8ea83061d99a505541d9": {
    "family": "butterfly",
    "roles": {
      "butterfly_cabbage_white_body": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "butterfly_cabbage_white_wing_L": {
        "canonical_role": "butterfly_wing_L",
        "pivot_three": [
          -0.005,
          0,
          -0.013
        ]
      },
      "butterfly_cabbage_white_wing_R": {
        "canonical_role": "butterfly_wing_R",
        "pivot_three": [
          0.005,
          0,
          -0.013
        ]
      }
    },
    "variant": 2
  },
  "8a1fc1fff01a5cdf4802c58e93f61205c1b588c18b2548edeb8d3a475faf467d": {
    "family": "butterfly",
    "roles": {
      "butterfly_cabbage_white_body_proxy": {
        "canonical_role": "butterfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "butterfly_cabbage_white_wing_L_proxy": {
        "canonical_role": "butterfly_wing_L",
        "pivot_three": [
          -0.005,
          0,
          -0.013
        ]
      },
      "butterfly_cabbage_white_wing_R_proxy": {
        "canonical_role": "butterfly_wing_R",
        "pivot_three": [
          0.005,
          0,
          -0.013
        ]
      }
    },
    "variant": 2
  },
  "246405dd1a2ba293337a56866e3b9103e00b829102ec839f93a255c5d45682f9": {
    "family": "dragonfly",
    "roles": {
      "dragonfly_body": {
        "canonical_role": "dragonfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "dragonfly_forewing_L": {
        "canonical_role": "dragonfly_forewing_L",
        "pivot_three": [
          -0.01,
          0,
          -0.025
        ]
      },
      "dragonfly_hindwing_L": {
        "canonical_role": "dragonfly_hindwing_L",
        "pivot_three": [
          -0.012,
          0,
          -0.006
        ]
      },
      "dragonfly_forewing_R": {
        "canonical_role": "dragonfly_forewing_R",
        "pivot_three": [
          0.01,
          0,
          -0.025
        ]
      },
      "dragonfly_hindwing_R": {
        "canonical_role": "dragonfly_hindwing_R",
        "pivot_three": [
          0.012,
          0,
          -0.006
        ]
      }
    }
  },
  "2abafd8fe03d9d43f9509a127192b491d24a791db8578b6e1a4135d422d0ebfa": {
    "family": "dragonfly",
    "roles": {
      "dragonfly_body_proxy": {
        "canonical_role": "dragonfly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "dragonfly_forewing_L_proxy": {
        "canonical_role": "dragonfly_forewing_L",
        "pivot_three": [
          -0.01,
          0,
          -0.025
        ]
      },
      "dragonfly_hindwing_L_proxy": {
        "canonical_role": "dragonfly_hindwing_L",
        "pivot_three": [
          -0.012,
          0,
          -0.006
        ]
      },
      "dragonfly_forewing_R_proxy": {
        "canonical_role": "dragonfly_forewing_R",
        "pivot_three": [
          0.01,
          0,
          -0.025
        ]
      },
      "dragonfly_hindwing_R_proxy": {
        "canonical_role": "dragonfly_hindwing_R",
        "pivot_three": [
          0.012,
          0,
          -0.006
        ]
      }
    }
  },
  "5cd2d6212f22170ced072ca310188bb3e135f65056f0ba127ed352bd7e7ca31a": {
    "family": "firefly",
    "roles": {
      "firefly_body": {
        "canonical_role": "firefly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "firefly_elytron_L": {
        "canonical_role": "firefly_elytron_L",
        "pivot_three": [
          -0.001,
          0.001,
          -0.004
        ]
      },
      "firefly_wing_L": {
        "canonical_role": "firefly_wing_L",
        "pivot_three": [
          -0.002,
          -0.001,
          -0.003
        ]
      },
      "firefly_elytron_R": {
        "canonical_role": "firefly_elytron_R",
        "pivot_three": [
          0.001,
          0.001,
          -0.004
        ]
      },
      "firefly_wing_R": {
        "canonical_role": "firefly_wing_R",
        "pivot_three": [
          0.002,
          -0.001,
          -0.003
        ]
      },
      "firefly_lantern": {
        "canonical_role": "firefly_lantern",
        "pivot_three": [
          0,
          0,
          0.009
        ]
      }
    }
  },
  "44ae5d6ef967b5892177968d9c9b8d8b5ef06b1ca21d89890f31558308bcd6fa": {
    "family": "firefly",
    "roles": {
      "firefly_body_proxy": {
        "canonical_role": "firefly_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "firefly_elytron_L_proxy": {
        "canonical_role": "firefly_elytron_L",
        "pivot_three": [
          -0.001,
          0.001,
          -0.004
        ]
      },
      "firefly_wing_L_proxy": {
        "canonical_role": "firefly_wing_L",
        "pivot_three": [
          -0.002,
          -0.001,
          -0.003
        ]
      },
      "firefly_elytron_R_proxy": {
        "canonical_role": "firefly_elytron_R",
        "pivot_three": [
          0.001,
          0.001,
          -0.004
        ]
      },
      "firefly_wing_R_proxy": {
        "canonical_role": "firefly_wing_R",
        "pivot_three": [
          0.002,
          -0.001,
          -0.003
        ]
      },
      "firefly_lantern_proxy": {
        "canonical_role": "firefly_lantern",
        "pivot_three": [
          0,
          0,
          0.009
        ]
      }
    }
  },
  "a99357de764804abbe6d8bb917a0d23bbefe808d2e36b2b656f4d19de46644da": {
    "family": "robin",
    "roles": {
      "bird_body": {
        "canonical_role": "bird_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "bird_head": {
        "canonical_role": "bird_head",
        "pivot_three": [
          0,
          0.011,
          -0.067
        ]
      },
      "bird_tail": {
        "canonical_role": "bird_tail",
        "pivot_three": [
          0,
          -0.024,
          0.06
        ]
      },
      "bird_feet_L": {
        "canonical_role": "bird_feet_L",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_feet_R": {
        "canonical_role": "bird_feet_R",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_wing_L": {
        "canonical_role": "bird_wing_L",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      },
      "bird_wing_R": {
        "canonical_role": "bird_wing_R",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      }
    }
  },
  "694491a947b4423bb8fc1d0dd0a6a568bbba9ca3f00f7f88d623afea6f4a9503": {
    "family": "robin",
    "roles": {
      "bird_body": {
        "canonical_role": "bird_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "bird_head": {
        "canonical_role": "bird_head",
        "pivot_three": [
          0,
          0.011,
          -0.067
        ]
      },
      "bird_tail": {
        "canonical_role": "bird_tail",
        "pivot_three": [
          0,
          -0.024,
          0.06
        ]
      },
      "bird_feet_L": {
        "canonical_role": "bird_feet_L",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_feet_R": {
        "canonical_role": "bird_feet_R",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_wing_L": {
        "canonical_role": "bird_wing_L",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      },
      "bird_wing_R": {
        "canonical_role": "bird_wing_R",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      }
    }
  },
  "1214a3790d12705a581a0e9e085654bf69721d4b5bf073cb79c29e25aba39ad1": {
    "family": "wren",
    "roles": {
      "bird_body": {
        "canonical_role": "bird_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "bird_head": {
        "canonical_role": "bird_head",
        "pivot_three": [
          0,
          0.011,
          -0.067
        ]
      },
      "bird_tail": {
        "canonical_role": "bird_tail",
        "pivot_three": [
          0,
          -0.024,
          0.06
        ]
      },
      "bird_feet_L": {
        "canonical_role": "bird_feet_L",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_feet_R": {
        "canonical_role": "bird_feet_R",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_wing_L": {
        "canonical_role": "bird_wing_L",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      },
      "bird_wing_R": {
        "canonical_role": "bird_wing_R",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      }
    }
  },
  "a86c5d802f5c63709d09833e63a04e16026b2ccfa120a3571938cc04ec2de770": {
    "family": "wren",
    "roles": {
      "bird_body": {
        "canonical_role": "bird_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "bird_head": {
        "canonical_role": "bird_head",
        "pivot_three": [
          0,
          0.011,
          -0.067
        ]
      },
      "bird_tail": {
        "canonical_role": "bird_tail",
        "pivot_three": [
          0,
          -0.024,
          0.06
        ]
      },
      "bird_feet_L": {
        "canonical_role": "bird_feet_L",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_feet_R": {
        "canonical_role": "bird_feet_R",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_wing_L": {
        "canonical_role": "bird_wing_L",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      },
      "bird_wing_R": {
        "canonical_role": "bird_wing_R",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      }
    }
  },
  "67a7dae3f7cdf1cdb157ca48006781f9a201e3ac76dc51fd8ee17de478715ad5": {
    "family": "swallow",
    "roles": {
      "bird_body": {
        "canonical_role": "bird_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "bird_head": {
        "canonical_role": "bird_head",
        "pivot_three": [
          0,
          0.011,
          -0.067
        ]
      },
      "bird_tail": {
        "canonical_role": "bird_tail",
        "pivot_three": [
          0,
          -0.024,
          0.06
        ]
      },
      "bird_feet_L": {
        "canonical_role": "bird_feet_L",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_feet_R": {
        "canonical_role": "bird_feet_R",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_wing_L": {
        "canonical_role": "bird_wing_L",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      },
      "bird_wing_R": {
        "canonical_role": "bird_wing_R",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      }
    }
  },
  "962430e963de711dc3512599949cf0bf0994350d31b90f01a45750c5f3e005eb": {
    "family": "swallow",
    "roles": {
      "bird_body": {
        "canonical_role": "bird_body",
        "pivot_three": [
          0,
          0,
          0
        ]
      },
      "bird_head": {
        "canonical_role": "bird_head",
        "pivot_three": [
          0,
          0.011,
          -0.067
        ]
      },
      "bird_tail": {
        "canonical_role": "bird_tail",
        "pivot_three": [
          0,
          -0.024,
          0.06
        ]
      },
      "bird_feet_L": {
        "canonical_role": "bird_feet_L",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_feet_R": {
        "canonical_role": "bird_feet_R",
        "pivot_three": [
          0,
          -0.04,
          0.005
        ]
      },
      "bird_wing_L": {
        "canonical_role": "bird_wing_L",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      },
      "bird_wing_R": {
        "canonical_role": "bird_wing_R",
        "pivot_three": [
          0,
          -0.016,
          0
        ]
      }
    }
  },
  "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2": {
    "family": "rabbit",
    "assetProfile": "rabbit-original-rig-study",
    "originalRigMode": "procedural",
    "clip": "Sitting",
    "clipTime": 0,
    "authoritativeProfile": true,
    "coatVariation": true,
    "furMode": "focus"
  },
  "f46341d730024ddb2a582438be85c30b4bfc391cb4b48d466302c39d781074a6": {
    "family": "rabbit",
    "assetProfile": "rabbit-original-rig-study",
    "originalRigMode": "procedural",
    "clip": "Sitting",
    "clipTime": 0,
    "authoritativeProfile": true,
    "coatVariation": true
  },
  "ae16fd0a1a14723513deb35b529174973934247a8b8dd5ef842b9c0dff2dfde6": {
    "family": "fish",
    "bones": [
      {
        "name": "fish_body"
      },
      {
        "name": "fish_head"
      },
      {
        "name": "fish_tail_1"
      },
      {
        "name": "fish_tail_2"
      },
      {
        "name": "fish_caudal"
      },
      {
        "name": "fish_dorsal"
      },
      {
        "name": "fish_anal"
      },
      {
        "name": "fish_pectoral_L"
      },
      {
        "name": "fish_pelvic_L"
      },
      {
        "name": "fish_pectoral_R"
      },
      {
        "name": "fish_pelvic_R"
      }
    ]
  },
  "a4f9555de163ced80c7ad5d39c51585de5f0493ec0c3566928f5da0d4fe4531a": {
    "family": "fish",
    "bones": [
      {
        "name": "fish_body"
      },
      {
        "name": "fish_head"
      },
      {
        "name": "fish_tail_1"
      },
      {
        "name": "fish_tail_2"
      },
      {
        "name": "fish_caudal"
      },
      {
        "name": "fish_dorsal"
      },
      {
        "name": "fish_anal"
      },
      {
        "name": "fish_pectoral_L"
      },
      {
        "name": "fish_pelvic_L"
      },
      {
        "name": "fish_pectoral_R"
      },
      {
        "name": "fish_pelvic_R"
      }
    ]
  }
};

THREE_ANIMAL_BINDINGS["fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"] = {
  "family": "firefly",
  "assetProfile": "photinus-male-anatomy04",
  "sha256": "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5",
  "roles": {
    "firefly_body": [
      0,
      0,
      0
    ],
    "firefly_elytron_L": [
      -0.00035,
      0.00065,
      -0.00235
    ],
    "firefly_wing_L": [
      -0.00085,
      0,
      -0.0021
    ],
    "firefly_elytron_R": [
      0.00035,
      0.00065,
      -0.00235
    ],
    "firefly_wing_R": [
      0.00085,
      0,
      -0.0021
    ],
    "firefly_lantern": [
      0,
      -0.0004,
      0.00435
    ]
  },
  "poses": {
    "flight_dark": {
      "min_m": [
        -0.011008594185113907,
        -0.00155610719230026,
        -0.00956205278635025
      ],
      "max_m": [
        0.011008594185113907,
        0.004345746245235205,
        0.006399999838322401
      ],
      "roles": {
        "firefly_body": {
          "pivot_m": [
            0,
            0,
            0
          ],
          "quaternion_xyzw_three": [
            0.0,
            0.0,
            -0.0,
            1.0
          ]
        },
        "firefly_elytron_L": {
          "pivot_m": [
            -0.00035,
            0.00065,
            -0.00235
          ],
          "quaternion_xyzw_three": [
            -0.10599463433027267,
            -0.3078307509422302,
            -0.3078307509422302,
            0.8940053582191467
          ]
        },
        "firefly_wing_L": {
          "pivot_m": [
            -0.00085,
            0,
            -0.0021
          ],
          "quaternion_xyzw_three": [
            0.0,
            0.0,
            -0.0,
            1.0
          ]
        },
        "firefly_elytron_R": {
          "pivot_m": [
            0.00035,
            0.00065,
            -0.00235
          ],
          "quaternion_xyzw_three": [
            -0.10599463433027267,
            0.3078307509422302,
            0.3078307509422302,
            0.8940053582191467
          ]
        },
        "firefly_wing_R": {
          "pivot_m": [
            0.00085,
            0,
            -0.0021
          ],
          "quaternion_xyzw_three": [
            0.0,
            0.0,
            -0.0,
            1.0
          ]
        },
        "firefly_lantern": {
          "pivot_m": [
            0,
            -0.0004,
            0.00435
          ],
          "quaternion_xyzw_three": [
            0.0,
            0.0,
            -0.0,
            1.0
          ]
        }
      },
      "FlightLegs": 1,
      "Folded": 0,
      "emission_strength": 0
    }
  }
};

Object.assign(THREE_ANIMAL_BINDINGS,ROBIN_CORE10_BINDINGS);

THREE_ANIMAL_BINDINGS["1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50"] = {
  "family": "dragonfly",
  "sha256": "1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50",
  "strictRoleBinds": true,
  "roles": {
    "dragonfly_body": {
      "canonical_role": "dragonfly_body",
      "pivot_three": [
        0,
        0,
        0
      ],
      "geometry_space": "local about pivot",
      "bind_matrix_column_major": [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]
    },
    "dragonfly_forewing_L": {
      "canonical_role": "dragonfly_forewing_L",
      "pivot_three": [
        -0.009,
        0.0015,
        -0.017
      ],
      "geometry_space": "local about pivot",
      "bind_matrix_column_major": [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        -0.009,
        0.0015,
        -0.017,
        1
      ]
    },
    "dragonfly_hindwing_L": {
      "canonical_role": "dragonfly_hindwing_L",
      "pivot_three": [
        -0.0075,
        0.0015,
        -0.005
      ],
      "geometry_space": "local about pivot",
      "bind_matrix_column_major": [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        -0.0075,
        0.0015,
        -0.005,
        1
      ]
    },
    "dragonfly_forewing_R": {
      "canonical_role": "dragonfly_forewing_R",
      "pivot_three": [
        0.009,
        0.0015,
        -0.017
      ],
      "geometry_space": "local about pivot",
      "bind_matrix_column_major": [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0.009,
        0.0015,
        -0.017,
        1
      ]
    },
    "dragonfly_hindwing_R": {
      "canonical_role": "dragonfly_hindwing_R",
      "pivot_three": [
        0.0075,
        0.0015,
        -0.005
      ],
      "geometry_space": "local about pivot",
      "bind_matrix_column_major": [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0.0075,
        0.0015,
        -0.005,
        1
      ]
    }
  }
};

THREE_ANIMAL_BINDINGS["1820dc705a12d727fef9baed022c3f5674b2703d75840dd78353bf1d6f29cb50"].canvasTextureFilter="area-mipmap";

Object.assign(THREE_ANIMAL_BINDINGS,BUTTERFLY_FOUR_WING_BINDINGS);
THREE_ANIMAL_BINDINGS["4aafc94cc8eb0fcf4408eed0646c93f15c7d3ae401b80d261848d502dfc65ee5"]={family:"fish",bones:THREE_ANIMAL_BINDINGS["ae16fd0a1a14723513deb35b529174973934247a8b8dd5ef842b9c0dff2dfde6"].bones.map(b=>({...b}))};
THREE_ANIMAL_BINDINGS["67843d62ef4ce3e3b44001c4972a5ff37d3d62850d627317de38574ae429271a"]={family:"fish",bones:THREE_ANIMAL_BINDINGS["ae16fd0a1a14723513deb35b529174973934247a8b8dd5ef842b9c0dff2dfde6"].bones.map(b=>({...b}))};

Object.assign(THREE_ANIMAL_BINDINGS,Object.fromEntries(Object.entries(WREN_CORE04_BINDINGS).map(([hash,definition])=>[hash,{...definition,selectedRuntime:true}])));

for(const hash of ["8e91f7f2c7af33df403cf470ef4913181d8cda3c4dca1371b19c0cecfbdb5086","0bf86659ca652a4bb3ba2bc242175b18d1f96fa9fdca819a50cd2f2a6126e9df"])THREE_ANIMAL_BINDINGS[hash]={...SWALLOW_ADULT01_BINDINGS[hash],selectedRuntime:true};
